import { apiInstance } from '@diamond/shared/utils';

export const deleteRecipeTag = async (token: string, id: string) => {
  return await apiInstance(token).delete(`/backoffice/recipe/${id}/tag`);
};
